export const cores = {
  padrao_systock: '#00875e',
  suavizacao_exponencial: '#da1a29',
  media_aritmetica_simples_trimestre: '#a7cc15',
  media_aritmetica_simples_semestre: '#f5cc17',
  media_aritmetica_simples_ano: '#f56217',
  media_geometrica: '#00c9d2',
  media_movel_ponderada: '#520647',
  mediana: '#0000ab',
};

export const index_tipos_projecao_vendas = {
  padrao_systock: 'padrao_systock',
  suavizacao_exponencial: 'suavizacao_exponencial',
  media_aritmetica_simples_trimestre: 'media_aritmetica_simples_trimestre',
  media_aritmetica_simples_semestre: 'media_aritmetica_simples_semestre',
  media_aritmetica_simples_ano: 'media_aritmetica_simples_ano',
  media_geometrica: 'media_geometrica',
  media_movel_ponderada: 'media_movel_ponderada',
  mediana: 'mediana',
  media_sazonal: 'media_sazonal',
};

export const descricao_index_tipo_projecao_vendas = {
  padrao_systock: 'Padrão Systock',
  suavizacao_exponencial: 'Suavização Exponencial',
  media_aritmetica_simples_trimestre: 'Média Aritmética Simples (TRIMESTRE)',
  media_aritmetica_simples_semestre: 'Média Aritmética Simples (SEMESTRE)',
  media_aritmetica_simples_ano: 'Média Aritmética Simples (ANO)',
  media_geometrica: 'Média Geométrica',
  media_movel_ponderada: 'Média Móvel Ponderada',
  mediana: 'Mediana',
  media_sazonal: 'Média Sazonal',
};
